import { DataArray, IDataArray, DocumentPartMap } from './../../shared/index';

export class Attribute implements IDataArray {
    public Id: number;
    public DisplayOrder: number;
    public Name: string;

    public Maps: DataArray<DocumentPartMap> = new DataArray<DocumentPartMap>(1);

    public GetById(): number {
        return this.Id;
    }
}
